import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';

/**
 * 移动端剪切工具栏
 */
@Feature()
export class CutFeature extends BaseMobileContextMenuFeature {
    id = config.name;

    /**
     * 剪切元素、文字
     * @private
     */
    public async cut() {
        const model = this.getSelectionService().selectedElements.getCurrentModel();

        const copyPaste = await this.getAppServices().editableServiceLayer?.copyPasteManager?.promise();
        // 编辑态中，处理文字复制
        if (model?.editorInstance?.isEditing) {
            // 这个库只支持真机，chrome f12模拟会报错
            copyPaste?.cutForMobile();
            this.getAppServices().viewableServiceLayer.toolbarStateManager.isMobileToolbarClick = true;
            return;
        }

        copyPaste?.triggerCutEvent();
    }
}
